// extracted by mini-css-extract-plugin
export default {"textContainer":"TextHeader_textContainer__cUKMC","text":"TextHeader_text__OUICL"};